<template>
    <div class="nothing">
        <div class="img"></div>
        <slot></slot>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="stylus" scoped>
.nothing
  text-align: center
  font-size: 0
  padding: 80px 0
  .img
    display: inline-block
    vertical-align: top
    width: 180px
    height: 113px
    commonBgImg('~pic/no-search.png', '~pic/no-search2.png')
    background-size: 100% !important
    background-repeat: no-repeat !important
  p
    commonColor(#BCBDC1, #666666)
    font-size: 14px
    margin-top: 16px
    line-height: 24px
    a
      color: rgba(250, 122, 80, 1)
      cursor: pointer
</style>
